import {Routes} from '@angular/router';
import {DataSurveyComponent} from './components/data-survey/data-survey.component';
import {DataSurveyExecutionComponent} from './components/data-survey-execution/data-survey-execution.component';
import {DataSurveyExecutionDetailsComponent} from './components/data-survey-execution-details/data-survey-execution-details.component';
import {EditSurveyComponent} from './components/edit-survey/edit-survey.component';
import {DataSurveyResponseComponent} from './components/data-survey-response/data-survey-response.component';
import {FormComponent} from './components/form/form.component';
import {AddCustomSurveyWorkflowComponent} from './components/add-custom-survey-workflow/add-custom-survey-workflow.component';
import {DataSurveyFormsComponent} from './components/data-survey-forms/data-survey-forms.component';
import {DataSurveyFormDesignerComponent} from './components/data-survey-form-designer/data-survey-form-designer.component';
import {ReportContentComponent} from './components/reports/report-content/report-content.component';
import {EditReportComponent} from './components/reports/edit-report/edit-report.component';
import {ReportTaskContentComponent} from './components/reports/report-task-content/report-task-content.component';
import {ParticipantsForFillingReportComponent} from './components/reports/participants-for-filling-report/participants-for-filling-report.component';
import {CanDeactivateComponentGuard} from '@core/services/can-deactivate-component-guard.service';
import {FlowChartDesignerComponent} from './components/flow-chart/flow-chart-designer/flow-chart-designer.component';
import {FlowChartContainerComponent} from './components/flow-chart/flow-chart-container/flow-chart-container.component';
import {AuthGuard} from '@core/services/auth-guard.service';
import {DataSurveyContentComponent} from './components/data-survey-content/data-survey-content.component';
import {DataSurveyReviewerRespondentContainerComponent} from './components/data-survey-reviewer-respondent-container/data-survey-reviewer-respondent-container.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';


export const dataSurveyRoutes: Routes = [
  {
    path: 'flowchart/link/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'flowchart/item-form-view/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-survey/response/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path     : 'data-survey/response/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-survey/response/:executionId/:userId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey/response/:executionId/:userId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey/templates',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey/participating',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey/scheduled',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-survey/field-mapping/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-survey/templates/:surveyId/edit',
    component: FlowChartContainerComponent
  },
  {
    path: 'data-survey/forms/design/:formId',
    component: DataSurveyFormDesignerComponent
  },
  {
    path: 'data-survey/response/:executionId',
    component: DataSurveyReviewerRespondentContainerComponent, // DataSurveyResponseComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'data-survey/form/:executionId',
    component: FormComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'data-survey/form/:executionId/:userId',
    component: FormComponent
  },
  {
    path: 'data-survey/custom/:surveyId',
    component: AddCustomSurveyWorkflowComponent
  },
  {
    path: 'data-survey/:surveyId',
    component: DataSurveyContentComponent
  },
  {
    path: 'data-survey/:surveyId/edit',
    component: EditSurveyComponent
  },
  {
    path: 'data-survey/:surveyId/:executionId',
    component: DataSurveyExecutionDetailsComponent
  },
  {
    path: 'dac6-reporter/reports',
    component: PlatformLinkCreatorComponent
  },
  /*{
    path: 'dac6-reporter/reports/:reportId',
    component: ReportTaskContentComponent
  },*/
  {
    path: 'dac6-reporter/reports/:reportId',
    component: PlatformLinkCreatorComponent
  },
  /*{
    path: 'dac6-reporter/reports/:reportId/:action',
    component: EditReportComponent
  },*/
  {
    path: 'dac6-reporter/reports/participants/:reportId/:itemId',
    component: ParticipantsForFillingReportComponent
  },
  {
    path: 'dac6-reporter/reports/:reportId/:action',
    component: PlatformLinkCreatorComponent
  }
];
